import { create } from 'zustand';

interface IBoardNameMappingStore {
  boardNameMapping: Record<string, string>;
  setBoardNameMapping: (boardNameMapping: Record<string, string>) => void;
}

export const zustandBoardNameMappingStore = create<IBoardNameMappingStore>(
  set => ({
    boardNameMapping: {},
    setBoardNameMapping: boardNameMapping => set({ boardNameMapping }),
  }),
);
